export const isDownloadInProgress = (folderId: any, state: (string | number)[]) => {
    const downloads = JSON.parse(sessionStorage.getItem('dowloadsData') || '{}');
  
    const normalize = (arr: any[]) =>
      (arr || []).map(Number).sort((a, b) => a - b);
  
    const inputState = normalize(state);
  
    return Object.values(downloads).some((entry: any) => {
      const entryState = normalize(entry.currentState);
      const statesEqual =
        inputState.length === entryState.length &&
        inputState.every((val, idx) => val === entryState[idx]);
  
      return (
        entry.folderId === folderId &&
        statesEqual &&
        entry.status === 'InProgress'
      );
    });
  };
  
  export const addDownloadInProgress = (id:any) => {
    const current = JSON.parse(sessionStorage.getItem('downloadsInProgress') || '[]');
    if (!current.includes(id)) {
      sessionStorage.setItem('downloadsInProgress', JSON.stringify([...current, id]));
    }
  };
